import { Style } from 'pdfmake/interfaces';

export const baseDefinitionStyles: Record<string, Style> = {
  documentTitle: {
    fontSize: 17,
    bold: true,
    alignment: 'center',
    margin: 10,
  },
  title: {
    fontSize: 15,
    bold: true,
    alignment: 'center',
    margin: 10,
  },
};
